import Container from '@mui/material/Container'
import { CreateCampaignHeader } from '~/features/campaign_create/Header'
import { CreateCampaignContext } from '~/contexts/CreateCampaignContext'
import { FC, useContext } from 'react'
import { NavigationButtons } from '../NavigationButtons'
import { useCampaignPageStepForm } from '../useCampaignPageStepForm'
import { FormProvider } from 'react-hook-form'
import { z } from 'zod'
import { SNS, snsSchema, validateSns } from '../../campaign_input/SNS'
import { Grid, Alert, Stack, Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import { getUnsupportedTagLanguageWarning } from '~/lib/sns'

export const SnsContents: FC = () => {
  const { campaign } = useContext(CreateCampaignContext)
  const { useFormMethods, onSubmit, onBack } = useCampaignPageStepForm<z.infer<typeof snsSchema>>({
    defaultValues: { snsRequirements: campaign.snsRequirements },
    schema: snsSchema.superRefine(validateSns),
  })

  // サポートされていない言語の警告メッセージを取得
  const unsupportedLanguageWarning = getUnsupportedTagLanguageWarning(campaign.desiredLanguages)
  return (
    <form onSubmit={onSubmit}>
      <CreateCampaignHeader title="SNSに関する情報について教えてください" onBack={onBack} />
      <Container sx={{ display: 'flex', flexDirection: 'column' }} maxWidth="md">
        <FormProvider {...useFormMethods}>
          <SNS
            description={
              <Grid container direction="column" gap={1} pt={1} pb={3}>
                <Alert severity="info" icon={<InfoIcon />}>
                  アカウント名とハッシュタグはインフルエンサーの投稿に記載されます。
                  <br />
                  アカウント名を登録して認知度アップに繋げましょう！
                </Alert>
                <Stack gap={1}>
                  <Typography variant="caption">※選択したSNSのいずれかで投稿されます。</Typography>
                  {unsupportedLanguageWarning && (
                    <Typography variant="caption">{unsupportedLanguageWarning}</Typography>
                  )}
                </Stack>
              </Grid>
            }
          />
        </FormProvider>
        <NavigationButtons />
      </Container>
    </form>
  )
}
